<style lang="scss">
.sp-image-picker {
  display: flex;
  &.small {
    .image-item {
      width: 64px;
      height: 64px;
    }
    .placeholder {
      height: 64px;
    }
  }
  .image-list-wrap {
    @include clearfix();
  }
  .image-item {
    width: 80px;
    height: 80px;
    border: 1px solid #d9d9d9;
    margin-right: 10px;
    position: relative;
    float: left;
    &.hidden{
      position: relative;
      &::after{
        content:'';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.4);
      }
    }
    &.drag {
      &:hover {
        .icon-tuozhuai {
          display: block;
        }
      }
    }
  }
  &.multiple {
    .image-item {
      margin-bottom: 10px;
    }
  }
  .placeholder {
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon-camera {
    font-size: 24px;
    color: #d9d9d9;
    line-height: initial;
    // margin-top: 12px;
  }
  .add-text {
    font-size: 12px;
    color: #999;
    line-height: initial;
  }
  .img-content {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  &:hover {
    .image-meta {
      display: block;
    }
  }
  // .image-meta {
  //   height: 20px;
  //   width: 100%;
  //   line-height: 20px;
  //   text-align: center;
  //   color: white;
  //   background-color: rgba(0, 0, 0, 0.4);
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   font-size: 12px;
  //   cursor: default;
  // }
  .image-tools{
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    line-height: 20px;
    display: flex;
    font-size: 12px;
    justify-content: space-between;
    padding: 0 2px;
    z-index: 8;
    background-color: rgba(0, 0, 0, 0.4);
    .icon-guankanliang{
      font-size: 18px;
    }
    .ecx-icon{
      cursor: pointer;
    }
  }
  .icon-tuozhuai {
    background: rgba(0, 0, 0, 0.7);
    display: none;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    color: #fff;
    position: absolute;
    z-index: 99;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
  }
  .icon-qingchuFilled {
    position: absolute;
    right: -7px;
    z-index: 99;
    top: -17px;
    font-size: 18px;
    color: #666;
  }
}
</style>
<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { isArray, isEmpty, isString, isObject } from '@/utils'
import draggable from 'vuedraggable'
export default {
  name: 'SpImagePicker',
  components: { draggable },
  props: {
    value: {
      type: [Object, Array, String]
    },
    max: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'string' // string | object 只针对value为数组时有效
    },
    size: {
      type: String,
      default: 'normal'
    },
    drag: {
      type: Boolean,
      default: false
    },
    down:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dragOptions: {
        animation: 300,
        forceFallback: false,
        scroll: true
      }
    }
  },
  computed: {
    ...mapGetters(['lang'])
  },
  watch: {
    value: {
      handler(nVal) {
        this.localValue = nVal
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    console.log('down',this.down)

  },
  methods: {
    // 图片添加
    async handleSelectImage() {
      const { data } = await this.$picker.image({
        multiple: this.max > 1,
        num: this.max > 1 ? this.max - this.localValue.length : 1,
        lang: this.lang,
      })
      if (isString(this.localValue)) {
        this.updateValue(data.url)
      } else if (isObject(this.localValue)) {
        this.updateValue(data)
      } else if (isArray(this.localValue)) {
        if (this.type == 'string') {
          const res = data.map(({ url }) => url)
          this.updateValue(this.localValue.concat(res))
        } else {
          data.map((item)=>{ item.is_hidden = 0 })
          this.updateValue(this.localValue.concat(data))
        }
      }
    },

    async onUpdateImage(index) {
      let val
      if (isArray(this.localValue)) {
        val = this.localValue[index]
      } else if (isObject(this.localValue)) {
        val = this.localValue.url
      } else {
        val = this.localValue
      }
      const { data } = await this.$picker.image({
        data: val
      })
      if (isArray(this.localValue)) {
        if (this.type == 'string') {
          Vue.set(this.localValue, index, data.url)
        } else {
          Vue.set(this.localValue, index, data)
        }
      } else if (isObject(this.localValue)) {
        this.localValue = data
      } else {
        this.localValue = data.url
      }
      this.updateValue(this.localValue)
    },

    updateValue(val) {
      console.log('updateValue========', val)
      this.$emit('input', val)
      this.$emit('onChange', val)
    },

    handleDeleteItem(index) {
      if (isArray(this.localValue)) {
        this.localValue.splice(index, 1)
      } else {
        this.localValue = isString(this.localValue) ? '' : {}
      }
      this.updateValue(this.localValue)
    },

    handleClickDown(src){
      const link = document.createElement('a');
      link.href = src;
      link.target = '_blank'
      link.download = src.split('/').pop();
      link.click();
      link.remove();
    },
    handleClickHide(hidden,index){
      console.log('this.localValue',this.localValue)
      console.log('index',index)

      let value = hidden == 0 ? hidden = 1 : hidden = 0
      if (isArray(this.localValue)) {
        this.localValue[index].is_hidden = value
      } else {
        this.localValue = this.localValue.is_hidden = value
      }

      Vue.set(this.localValue, index, this.localValue[index])

      this.updateValue(this.localValue)
    },
    _renderImage(item, index = 0) {
      return (
        <div class={['image-item', { 'drag': this.drag },{'hidden':item.is_hidden==1}]} key={`image-item__${index}`}>
          <i class='ecx-icon icon-tuozhuai' />
          <i
            class='ecx-icon icon-qingchuFilled'
            on-click={this.handleDeleteItem.bind(this, index)}
          />
          <el-image class='img-content' src={item?.url || item} fit='cover' />

          { this.down ? (
            <span class='image-tools'>
              <i onClick={()=>this.handleClickDown(item?.url || item)} class='ecx-icon icon-xiazai'></i>
              <i onClick={()=>this.handleClickHide(item.is_hidden,index)} class={item.is_hidden === 1 ? 'icon-buxianshi ecx-icon' : 'icon-guankanliang ecx-icon'}></i>
            </span>):( <span v-else class='image-meta' on-click={this.onUpdateImage.bind(this, index)}> 更换图片 </span> )
          }
        </div>
      )
    }
  },
  render() {
    const { value, max, size } = this
    return (
      <div
        class={[
          'sp-image-picker',
          size,
          {
            'multiple': max > 1
          }
        ]}
      >
        {max > 1 && (
          <draggable
            class='list-container'
            list={value}
            disabled={!this.drag}
            options={this.dragOptions}
            handle='.icon-tuozhuai'
          >
            {value.map((item, index) => this._renderImage(item, index))}
          </draggable>
        )}
        {max > 1 && value.length < max && (
          <div class='image-item placeholder' on-click={this.handleSelectImage}>
            <i class='iconfont icon-camera' />
            <div class='add-text'>{this.lang == 'zh'?'图片':'picture'}({`${value.length}/${max}`})</div>
          </div>
        )}

        {max == 1 && !isEmpty(value) && this._renderImage(value)}
        {max == 1 && isEmpty(value) && (
          <div class='image-item placeholder' on-click={this.handleSelectImage}>
            <i class='iconfont icon-camera' />
            <div class='add-text'>{this.lang == 'zh'?'添加图片':'Add Picture'}</div>
          </div>
        )}
      </div>
    )
  }
}
</script>
